import React, {FC, forwardRef, useState} from 'react'
import {ID, useDebounce} from '../../../helpers'
import {useIntl} from 'react-intl'
import {useQuery} from 'react-query'
import {filterByValue} from '../../../../app/modules/user/components/users-list/core/_requests'
import {useAuth} from '../../../../app/modules/auth'
import {useListView} from '../../modals/task/core/ListViewProvider'
import {useSearchParams} from 'react-router-dom'
import {Dropdown} from 'react-bootstrap'
import {TaskTemplateEditModalWrapper} from '../../../../app/modules/task-templates/components/TaskTemplateEditModalWrapper'

type CustomToggleProps = {
  children: React.ReactNode
  onClick: (event: React.MouseEvent<HTMLAnchorElement, MouseEvent>) => {}
}

const Search: FC = () => {
  const intl = useIntl()
  const [value, setValue] = useState<string>('')
  const {currentUser} = useAuth()
  const [showModal, setShowModal] = useState<boolean>(false)
  const {setItemIdForUpdate} = useListView()
  const [action, setAction] = useState<boolean>(false)

  const [searchParams, setSearchParams] = useSearchParams()
  const [taskByIdURL, setTaskByIdURL] = useState<ID>()

  const debouncedSearchTerm = useDebounce(value, 200)

  const {data: searchData, isLoading} = useQuery([debouncedSearchTerm], () =>
    debouncedSearchTerm ? filterByValue(debouncedSearchTerm) : Promise.resolve(undefined)
  )

  const openView = (file: string | undefined) => {
    window.open(process.env.REACT_APP_THEME_API_URL + '/storage/' + file, '_blank')
  }

  const openEditModal = (taskIdParam: ID) => {
    const newParams = new URLSearchParams(searchParams)
    newParams.set('taskId', taskIdParam!.toString()!)
    setSearchParams(newParams)
    setItemIdForUpdate(taskIdParam)
    setTaskByIdURL(taskIdParam)
    setShowModal(true)
    setAction(true)
  }

  const CustomToggle = forwardRef((props: CustomToggleProps, ref: React.Ref<HTMLAnchorElement>) => (
    <a
      ref={ref}
      onClick={(e) => {
        e.preventDefault()
        props.onClick(e)
      }}
    >
      {props.children}
    </a>
  ))

  return (
    <>
      <div className='d-flex align-items-center'>
        <Dropdown>
          <Dropdown.Toggle as={CustomToggle}>
            <div className='btn btn-icon btn-custom w-30px h-30px w-md-40px h-md-40px'>
              <i className='bi bi-search fs-3'></i>
            </div>
          </Dropdown.Toggle>

          <Dropdown.Menu className='menu menu-sub menu-sub-dropdown p-7 w-325px w-md-375px mt-8'>
            <div className='position-relative'>
              <i className='bi bi-search fs-4 text-gray-500 position-absolute top-50 translate-middle-y ms-0'></i>

              <input
                type='text'
                className='form-control form-control-flush ps-10'
                name='search'
                value={value}
                onChange={(e: any) => {
                  setValue(e.target.value)
                }}
                placeholder={intl.formatMessage({id: 'FORM.INPUT.SEARCH.NAVBAR'})}
              />

              {isLoading && (
                <span className='position-absolute top-50 end-0 translate-middle-y lh-0 me-1'>
                  <span className='spinner-border h-15px w-15px align-middle text-gray-400' />
                </span>
              )}

              {!!debouncedSearchTerm && (
                <span
                  className='btn btn-flush btn-active-color-primary position-absolute top-50 end-0 translate-middle-y lh-0'
                  onClick={() => setValue('')}
                >
                  <i className='bi bi-x-lg fs-5'></i>
                </span>
              )}
            </div>
            {/* <div
              className='position-absolute top-50 end-0 translate-middle-y'
              data-kt-search-element='toolbar'
            >
              <div
                data-kt-search-element='preferences-show'
                className='btn btn-icon w-20px btn-sm btn-active-color-primary me-8'
                data-bs-toggle='tooltip'
                onClick={() => {
                  setMenuState('preferences')
                }}
                title='Show search preferences'
              >
                <KTSVG path='/media/icons/duotune/coding/cod001.svg' className='svg-icon-1' />
              </div>
            </div> */}

            {searchData?.data &&
            searchData.data[0].clients?.length == 0 &&
            searchData.data[0].contracts?.length == 0 &&
            searchData.data[0].projects?.length == 0 &&
            searchData.data[0].tasks?.length == 0 &&
            searchData.data[0].wikis?.length == 0 ? (
              <div className='d-block text-center'>
                <div className='pt-10 pb-10'>
                  <i className='bi bi-search fs-1 text-gray-500 opacity-50'></i>
                </div>

                <div className='pb-15 fw-bold'>
                  <h3 className='text-gray-600 fs-5 mb-2'>
                    {intl.formatMessage({id: 'FORM.INPUT.SEARCH.NAVBAR.NOT.FOUND'})}
                  </h3>
                  <div className='text-muted fs-7'>
                    {intl.formatMessage({id: 'FORM.INPUT.SEARCH.NAVBAR.NOT.FOUND.TEXT'})}
                  </div>
                </div>
              </div>
            ) : (
              <div>
                <div className='scroll-y mh-200px mh-lg-350px'>
                  {(currentUser?.administrator || currentUser?.manager) &&
                  searchData?.data[0].clients &&
                  searchData?.data[0].clients?.length > 0 ? (
                    <>
                      <h3
                        className='fs-5 text-muted m-0 pt-5 pb-5'
                        data-kt-search-element='category-title'
                      >
                        {intl.formatMessage({id: 'MENU.CLIENTS'})}
                      </h3>
                    </>
                  ) : null}

                  {searchData?.data[0].clients?.map((client_row, index) => {
                    return (
                      <>
                        {(currentUser?.administrator || currentUser?.manager) ? (
                          <a
                            href={`/clients/${client_row.client_id}`}
                            className='d-flex text-dark text-hover-primary align-items-center mb-5'
                          >
                            <div className='d-flex flex-column'>
                              <span className='fs-6 fw-bold'>{client_row.client_name}</span>
                            </div>
                          </a>
                        ) : null}
                      </>
                    )
                  })}

                  {searchData?.data[0].tasks && searchData?.data[0].tasks?.length > 0 ? (
                    <>
                      <h3
                        className='fs-5 text-muted m-0 pb-5'
                        data-kt-search-element='category-title'
                      >
                        {intl.formatMessage({id: 'MENU.TASKS'})}
                      </h3>
                    </>
                  ) : null}

                  {searchData?.data[0].tasks?.map((task_row, index) => {
                    return (
                      <>
                        <a
                          onClick={(e) => {
                            e.preventDefault()
                            openEditModal(task_row.task_id)
                          }}
                          href='/#'
                          className='d-flex text-dark text-hover-primary align-items-center mb-5'
                        >
                          <div className='d-flex flex-column justify-content-start fw-bold'>
                            <span className='fs-6 fw-bold'>{task_row.task_name}</span>
                            <span className='fs-7 fw-bold text-muted'>
                              #{task_row.task_id} - {task_row.project_name}
                            </span>
                          </div>
                        </a>
                      </>
                    )
                  })}

                  {searchData?.data[0].projects && searchData?.data[0].projects?.length > 0 ? (
                    <>
                      <h3
                        className='fs-5 text-muted m-0 pb-5'
                        data-kt-search-element='category-title'
                      >
                        {intl.formatMessage({id: 'MENU.PROJECTS'})}
                      </h3>
                    </>
                  ) : null}

                  {searchData?.data[0].projects?.map((project_row, index) => {
                    return (
                      <>
                        <a
                          href={`/projects/${project_row.project_id}`}
                          className='d-flex text-dark text-hover-primary align-items-center mb-5'
                        >
                          <div className='d-flex flex-column justify-content-start fw-bold'>
                            <span className='fs-6 fw-bold'>{project_row.project_name}</span>
                            <span className='fs-7 fw-bold text-muted'>
                              #{project_row.project_id} - {project_row.client_name}
                            </span>
                          </div>
                        </a>
                      </>
                    )
                  })}

                  {searchData?.data[0].wikis && searchData?.data[0].wikis?.length > 0 ? (
                    <>
                      <h3
                        className='fs-5 text-muted m-0 pb-5'
                        data-kt-search-element='category-title'
                      >
                        WIKI
                      </h3>
                    </>
                  ) : null}

                  {searchData?.data[0].wikis?.map((wiki_row, index) => {
                    return (
                      <>
                        <a
                          href={`/wiki/overview/${wiki_row.wiki_id}`}
                          className='d-flex text-dark text-hover-primary align-items-center mb-5'
                        >
                          <div className='d-flex flex-column'>
                            <span className='fs-6 fw-bold'>{wiki_row.wiki_title}</span>
                            <span className='fs-7 fw-bold text-muted'>
                              {wiki_row.wiki_category}
                            </span>
                          </div>
                        </a>
                      </>
                    )
                  })}

                  {(currentUser?.administrator || currentUser?.manager) &&
                  searchData?.data[0].contracts &&
                  searchData.data[0].contracts.length > 0 ? (
                    <>
                      <h3
                        className='fs-5 text-muted m-0 pt-5 pb-5'
                        data-kt-search-element='category-title'
                      >
                        {intl.formatMessage({id: 'MENU.CONTRACTS'})}
                      </h3>
                    </>
                  ) : null}

                  {searchData?.data[0].contracts?.map((contract_row, index) => {
                    return (
                      <>
                        {(currentUser?.administrator || currentUser?.manager) ? (
                          <a
                            onClick={() => openView(contract_row.contract_file)}
                            href='/#'
                            className='d-flex text-dark text-hover-primary align-items-center mb-5'
                          >
                            <div className='d-flex flex-column'>
                              <span className='fs-6 fw-bold'>{contract_row.contract_name}</span>
                              <span className='fs-7 fw-bold text-muted'>
                                {contract_row.project_name} - {contract_row.client_name}
                              </span>
                            </div>
                          </a>
                        ) : null}
                      </>
                    )
                  })}
                </div>
              </div>
            )}
          </Dropdown.Menu>
        </Dropdown>

        {/* <form className={`pt-1 ${menuState === 'preferences' ? '' : 'd-none'}`}>
          <h3 className='fw-bold text-dark mb-7'>
            {intl.formatMessage({id: 'FORM.INPUT.SEARCH.CATEGORIES'})}
          </h3>

          <div className='pb-4 border-bottom'>
            <label className='form-check form-switch form-switch-sm form-check-custom form-check-solid flex-stack'>
              <span className='form-check-label text-gray-700 fs-6 fw-bold ms-0 me-2'>
                {intl.formatMessage({id: 'FORM.INPUT.SEARCH.CATEGORIES.TASKS'})}
              </span>

              <input
                className='form-check-input'
                type='checkbox'
                value='1'
                name='search_categories_tasks'
                defaultChecked
              />
            </label>
          </div>

          <div className='py-4 border-bottom'>
            <label className='form-check form-switch form-switch-sm form-check-custom form-check-solid flex-stack'>
              <span className='form-check-label text-gray-700 fs-6 fw-bold ms-0 me-2'>
                {intl.formatMessage({id: 'FORM.INPUT.SEARCH.CATEGORIES.PROJECTS'})}
              </span>
              <input
                className='form-check-input'
                type='checkbox'
                value='1'
                name='search_categories_projects'
                defaultChecked
              />
            </label>
          </div>

          <div className='py-4 border-bottom'>
            <label className='form-check form-switch form-switch-sm form-check-custom form-check-solid flex-stack'>
              <span className='form-check-label text-gray-700 fs-6 fw-bold ms-0 me-2'>
                {intl.formatMessage({id: 'FORM.INPUT.SEARCH.CATEGORIES.CLIENTS'})}
              </span>
              <input
                className='form-check-input'
                type='checkbox'
                value='1'
                name='search_categories_clients'
                defaultChecked
              />
            </label>
          </div>

          <div className='py-4 border-bottom'>
            <label className='form-check form-switch form-switch-sm form-check-custom form-check-solid flex-stack'>
              <span className='form-check-label text-gray-700 fs-6 fw-bold ms-0 me-2'>
                {intl.formatMessage({id: 'FORM.INPUT.SEARCH.CATEGORIES.WIKI'})}
              </span>
              <input
                className='form-check-input'
                type='checkbox'
                name='search_categories_wiki'
                value='1'
                defaultChecked
              />
            </label>
          </div>

          <div className='py-4 border-bottom'>
            <label className='form-check form-switch form-switch-sm form-check-custom form-check-solid flex-stack'>
              <span className='form-check-label text-gray-700 fs-6 fw-bold ms-0 me-2'>
                {intl.formatMessage({id: 'FORM.INPUT.SEARCH.CATEGORIES.CONTRACTS'})}
              </span>
              <input
                className='form-check-input'
                type='checkbox'
                value='1'
                name='search_categories_contracts'
                defaultChecked
              />
            </label>
          </div>

          <div className='d-flex justify-content-end pt-7'>
            <button
              onClick={(e) => {
                e.preventDefault()
                setMenuState('main')
              }}
              className='btn btn-sm btn-light fw-bolder btn-active-light-primary me-2'
            >
              {intl.formatMessage({id: 'FORM.INPUT.SEARCH.CATEGORIES.BUTTON.CANCEL'})}
            </button>
            <button className='btn btn-sm fw-bolder btn-primary'>
              {intl.formatMessage({id: 'FORM.INPUT.SEARCH.CATEGORIES.BUTTON.SAVE'})}
            </button>
          </div>
        </form> */}
      </div>

      <TaskTemplateEditModalWrapper />
    </>
  )
}

export {Search}
